import React, { useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import Navbar from '../Navbar';
import Footer from '../footer/Footer';
import calendaricon from '../../assets/images/calendaricon.png'
import CalendarHook from './CalendarHook';
function CalendarPage() {
  const { handleClassDetail, value, setValue, selectedData, handleDateClick, data } = CalendarHook();
  const regularDates = data['Regular Module']?.map(item => item.date);
  const adaptiveDates = data['Adaptive Module']?.map(item => item.date);

  const tileClassName = ({ date }) => {
    const formattedDate = date.toLocaleDateString('en-CA');
    if (regularDates?.includes(formattedDate)) {
      return 'regular-module';
    }
    if (adaptiveDates?.includes(formattedDate)) {
      return 'adaptive-module';
    }
    return '';
  };


  return (
    <div>
      <Navbar />
      {/* <div className='pt-3 innerBg'>
        <h1 style={{ color: 'white', fontWeight: '600' }}>Calendar</h1>
      </div> */}
      <div className='py-5 my-3'>

        <div className='querycard'>
          <Calendar onChange={setValue} value={value}
            onClickDay={handleDateClick}
            tileClassName={tileClassName}
          />
          <div>
            <div className='d-flex mt-4'><div className='me-4 yellowdiv'></div><p className='mb-0 ms-3'><b>Indicates Today's Date</b></p></div>
          </div>
          <div>
            <div className="d-flex align-items-center mt-4">
              <div className="me-4 pinkdiv"></div>
              <div className="vertical-line"></div>
              <div className="me-4 maroondiv"></div>
              <p className='mb-0 ms-3'><b>Indicates Scheduled Class</b></p></div>
          </div>
          {selectedData.length > 0 ? (
            <div>
              <div className="my-4">
                <div
                  className="py-4 text-center"
                  style={{
                    background: 'linear-gradient(90deg, rgba(171, 65, 74, 0) 0%, rgba(171, 65, 74, 0.1) 52%, rgba(171, 65, 74, 0) 100%)',
                  }}
                >
                  <strong className="mt-4">Classes on {value.toDateString()}</strong>
                </div>
              </div>
              <div className="mt-4">
                {/* Group classes by date and map them */}
                <div className="row mb-4">
                  {selectedData.map((event, index) => {
                    let backgroundColor = '';
                    let borderColor = '';

                    switch (event.class_type) {
                      case 'regular':
                        backgroundColor = '#FE9DA5';
                        borderColor = '#FE9DA5';
                        break;
                      case 'adaptive':
                        backgroundColor = '#A83942';
                        borderColor = '#A83942';
                        break;
                      case 'registration':
                        backgroundColor = '#C5E1A5';
                        borderColor = '#C5E1A5';
                        break;
                      case 'advance':
                        backgroundColor = '#FE9DA5';
                        borderColor = '#FE9DA5';
                        break;
                      default:
                        backgroundColor = '#ccc';
                        borderColor = '#ccc';
                    }

                    return (
                      <div
                        key={index}
                        className="col-12 col-sm-6 col-md-3 me-5 ms-5 timetable"
                        style={{
                          padding: '0px',
                          borderRadius: '18px',
                          border: `1.69px solid ${borderColor}`,
                        }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            padding: '10px',
                            borderRadius: '17px',
                            backgroundColor: backgroundColor,
                          }}
                        >
                          <div>
                            <img
                              src={calendaricon}
                              alt="Class"
                              style={{ width: '70px', height: '70px', marginRight: '20px' }}
                            />
                          </div>
                          <div>
                            <p className="fw white">
                              <strong> </strong> {event.class || 'N/A'}
                            </p>
                            <p className="fw white">
                              <strong></strong> {event.start_time.replace(":00", "") || "N/A"} - {event.end_time.replace(":00", "") || "N/A"}
                            </p>
                            <p className="fw white">
                              <strong> </strong> {event.hours || 'N/A'}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex justify-content-end my-3 me-2">
                          <button
                            className="btn"
                            style={{ color: '#369A02', border: '1px solid #369A02' }}
                            onClick={() => handleClassDetail(event)}
                          >
                            Detailed Schedule
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : (
            <span
              style={{
                display: 'inline-block',
                margin: '20px',
                backgroundColor: 'black',
                color: 'white',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
              }}
            >
              <strong>No events on this date</strong>
            </span>
          )}

        </div>
      </div>
      <Footer />

    </div>
  );
}

export default CalendarPage;
